import axios from "axios";
import { handlerError } from "utils";

const BASE_URL = "/company/internal-transfer";

export const getInternalTransferParents = async (query, page, size) => {
    try {
        const res = await axios.get(`${BASE_URL}/parents`, { params: { query: query || undefined, page, size } });
        return { data: res.data.data || [], total: res.data.total || 0 };
    } catch (ex) {
        handlerError(ex);
        return { data: [], total: 0 };
    }
};

export const getInternalTransferCompanies = async (parent, page, size) => {
    try {
        const res = await axios.get(`${BASE_URL}/companies`, { params: { parent: parent || undefined, page, size } });
        return { data: res.data.data || [], total: res.data.total || 0 };
    } catch (ex) {
        handlerError(ex);
        return { data: [], total: 0, failed: true };
    }
};

export const getAllInternalTransferCompanies = async (parent) => {
    try {
        const res = await axios.get(`${BASE_URL}/companies/all`, { params: { parent: parent || undefined } });
        return res.data.data || [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const getInternalTransferBalance = async (companyId, parent) => {
    try {
        const res = await axios.get(`${BASE_URL}/companies/${companyId}/balance`, { params: { parent: parent || undefined } });
        return res.data.balance;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const createInternalTransfer = async (body) => {
    try {
        const res = await axios.post(BASE_URL, body);
        return { httpStatus: res.status, ...res.data };
    } catch (ex) {
        if (ex.response && ex.response.data && ex.response.data.status) {
            return { httpStatus: ex.response.status, ...ex.response.data };
        }
        return { httpStatus: ex.response ? ex.response.status : null, ...handlerError(ex, false) };
    }
};

export const getInternalTransferStatement = async (companyId, { parent, status, dates, page, size, listAll } = {}) => {
    try {
        const res = await axios.get(`${BASE_URL}/${companyId}/statement`, {
            params: {
                parent: parent || undefined,
                status: status || undefined,
                dates: dates || undefined,
                page,
                size,
                listAll: listAll || undefined
            }
        });
        return { data: res.data.data || [], total: res.data.total || 0, company: res.data.company || null };
    } catch (ex) {
        handlerError(ex);
        return { data: [], total: 0, company: null };
    }
};
